import React from "react";
import { Card, CardContent, Chip, Stack } from "@mui/material";
import MDTypography from "components/MDTypography";

export default function NodeTooltip({ node }) {
  if (!node) return null;


  let severityNum;
  const sev = node.severity;

  if (sev === "🟢" || sev === 0) severityNum = 0;
  else if (sev === "🟡" || sev === 1) severityNum = 1;
  else if (sev === "🟠" || sev === 2) severityNum = 2;
  else if (sev === "🔴" || sev === 3) severityNum = 3;
  else if (sev === "🟤" || sev === 4) severityNum = 4;
  else severityNum = null;

  const severityMap = {
    0: { label: "OK", color: "success", emoji: "🟢" },
    1: { label: "Warning", color: "error", emoji: "🟡" },
    2: { label: "Critical", color: "error", emoji: "🟠" },
    3: { label: "Down", color: "error", emoji: "🔴" },
    4: { label: "Unknown", color: "default", emoji: "🟤" },
  };

  const severity = severityMap[severityNum] || {
    label: "N/A",
    color: "default",
    emoji: "❓",
  };

  return (
    <Card
      sx={{
        minWidth: 200,
        boxShadow: 3,
        borderRadius: 2,
      }}
    >
      <CardContent>
        <MDTypography variant="subtitle1" fontWeight="bold" gutterBottom style={{textAlign:"center"}}>
          {node.name}
        </MDTypography>
        <hr/> 
        <Stack spacing={0.5}>
          <MDTypography variant="body2">Category: {node.category}</MDTypography>
          <MDTypography variant="body2">IP: {node.ip}</MDTypography>
          <MDTypography variant="body2">
            Status: {node.status ? "Up" : "Down"}
          </MDTypography>
          <Stack direction="row" alignItems="center" spacing={1}>
            <MDTypography variant="body2">Severity:</MDTypography>
            <Chip
              label={`${severity.label}`}
              color={severity.color}
              size="small"
              sx={{ fontWeight: "bold" }}
            />
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
}
